import { FC } from 'react';

import { StyledBurger } from './styled';

export interface IHamburgerMenu {
  isOpen: boolean;
  toogleMenuOpen: () => void;
}

const HamburgerMenu: FC<IHamburgerMenu> = ({ isOpen, toogleMenuOpen }) => (
  <StyledBurger
    isOpen={isOpen}
    onClick={toogleMenuOpen}
    data-testid='hamburger-menu-button'
  >
    <div />
    <div />
    <div />
  </StyledBurger>
);

export default HamburgerMenu;
